<template>
  <div id="app">
    <Squadron/>
  </div>
</template>

<script>
  import Squadron from './components/Squadron.vue';

  export default {
    name: 'App',
    components: {
      Squadron,
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "./vars";

  html {
    height: 100%;
    font-size: 62.5%;
    -webkit-font-smoothing: antialiased;
  }

  body {
    font-size: 1.3rem;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    /*font-family: john-doe,sans-serif;*/
    /*font-weight: 400;*/
    /*font-style: normal;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $text-color;
  }

  .decorative-font {
    font-family: badaboom-pro, sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .typewriter-font {
    font-family: john-doe,sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .typewriter-font-bold {
    font-family: john-doe,sans-serif;
    font-weight: 700;
    font-style: normal;
  }

  .johndoe-font {
    font-family: john-doe,sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .johndoe-font-bold {
    font-family: john-doe,sans-serif;
    font-weight: 700;
    font-style: normal;
  }


  .typeka-font {
    font-family: typeka,sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .typeka-font-bold {
    font-family: typeka,sans-serif;
    font-weight: 700;
    font-style: normal;
  }

  .typeka-font-mix {
    font-family: typeka,sans-serif;
    font-weight: 500;
    font-style: normal;
  }


</style>
